import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '../../../../components/ui/Card'
import { DataTableNew } from '../../../../components/table-components/data-table'
import DataTableColumnHeader from '../../../../components/table-components/data-table-column-header'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAssetAction } from '../../../../store/actions/admin/assetAction'
import { useNavigate } from 'react-router-dom';
import _debounce from "lodash/debounce"
import useDebounce from '../../../../hooks/useDebounce'

const AssetsContent = () => {
    const { assetData } = useSelector(state => state)
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1)
    const [perPage, setPerPage] = useState(10);
    const [firstTime, setFirstTime] = useState(true)
    const [editedData, setEditedData] = useState(null);
    const [sortingValue, setSortingValue] = useState(1);
    const [addAssetsModel, setAddAssetsModel] = useState(false);
    const [onSearchValue, setOnSearchValue] = useState("");
    const [search, setSearch] = useState("");


    useEffect(() => {
        setFirstTime(false)
    }, [])

    useEffect(() => {
        if (addAssetsModel === false) {
            setEditedData(null)
        }
    }, [addAssetsModel])



    const onChange = (filter) => {
        setCurrentPage(filter?.page)
        setPerPage(filter?.perPage)
        const filterData = {
            ...filter,
            search: onSearchValue || "",
            sortCountry: sortingValue || 1
        }
        
        dispatch(fetchAssetAction(filterData))
    }





    useEffect(() => {
        const filterData = {
            page: currentPage,
            perPage: perPage,
            search: onSearchValue,
            sortCountry: sortingValue
        }
        !firstTime && dispatch(fetchAssetAction(filterData))

    }, [search, sortingValue]);

    const debouncedText = useDebounce(onSearchValue,200);


    useEffect(() => {
        setSearch(debouncedText)
    },[debouncedText])


    const onShowAssets = () => {
        setAddAssetsModel(true)
    }

    const onHideAssets = () => {
        setAddAssetsModel(false)
    }

    const handleEditAsset = (data) => {
        setEditedData(data)
        setAddAssetsModel(true)
    }

    const navigatePage = (rows) => {
        const slugName = `${rows?.data?.country?.alpha2Code}-${rows?.slug}-${rows?.curve}`
        const navigatePath = decodeURIComponent(slugName?.trim()?.replace(/\s+/g, "-"))
        navigate('/data/asset/' + navigatePath, {
            state: {
                data: rows
            }
        })
    }

    const data = assetData && assetData?.records?.length > 0 ? assetData.records.map((item) => {
        return {
            id: item?._id,
            Asset_Id: item?.assetId ?? "-",
            Name: item?.name,
            country: item?.country?.countryName || '-',
            currency: item?.currency?.currency || '-',
            curve: item?.interestRateDataType?.type || '-',
            week: item?.interestRateDataTypeAsset?.week ?? '-',
            month: item?.interestRateDataTypeAsset?.month ?? '-',
            year: item?.interestRateDataTypeAsset?.year ?? '-',
            value: item?.interestRateDataTypeAsset?.value ?? "-",
            tenure: item?.interestRateDataTypeAsset?.maturity || '-',
            slug: item?.interestRateDataTypeAsset?.slug || '-',
            description: item?.description || '-',
            data: item
        }
    }) : []

    const columns = [
        {
            accessorKey: "Asset_Id",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Asset Id" setSortingValue={setSortingValue} />
                <>Asset Id</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.Asset_Id}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "Name",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Name" setSortingValue={setSortingValue} />
                <>Name</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.Name}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "country",
            header: ({ column }) => (
                <DataTableColumnHeader column={column} title="Country" setSortingValue={setSortingValue} />
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.country}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "curve",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Curve" setSortingValue={setSortingValue} />
                <>Curve</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.curve}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "tenure",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Tenor" setSortingValue={setSortingValue} />
                <>Tenor</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center text-[#2487EE] hover:underline cursor-pointer' onClick={(e) => { navigatePage(row?.original); }} >{row?.original?.tenure ?? "-"}</span>
            },
            enableSorting: true,

        },

        {
            accessorKey: "value",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Rate" setSortingValue={setSortingValue} />
                <>Rate</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.value}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "currency",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Currency" setSortingValue={setSortingValue} />
                <>Currency</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.currency}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "week",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Week" setSortingValue={setSortingValue} />
                <>Week</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.week}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "month",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Month" setSortingValue={setSortingValue} />
                <>Month</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.month}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "year",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Year" setSortingValue={setSortingValue} />
                <>Year</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center'>{row?.original?.year}</span>
            },
            enableSorting: true,
        },
        {
            accessorKey: "description",
            header: ({ column }) => (
                // <DataTableColumnHeader column={column} title="Description" setSortingValue={setSortingValue} />
                <>Description</>
            ),
            cell: ({ row }) => {
                return <span className='flex items-center min-w-[300px]'>{row?.original?.description}</span>
            },
            enableSorting: true,
        },
    ];

    const onSearchChange = (e) => {
        setOnSearchValue(e?.target?.value)
    }


    return (
        <div className='p-5'>
            <Card className="bg-white p-4">
                <CardContent className="p-2">
                    <DataTableNew columns={columns} data={data} onChange={onChange} filterName={'Name'}
                        isRightNew={true}
                        isOldHeaderHide={true}
                        onSearchChange={onSearchChange}
                        isRightSearch={true}
                        isLeftHeaderButtons={false}
                        isRight={true} />


                </CardContent>
            </Card>
        </div>
    )
}


export default AssetsContent
